import * as React from "react";
import { cx } from "../../utils/dom";
import { Color } from "../../utils/theme";

interface SeparatorProps extends React.ComponentPropsWithoutRef<"div"> {
  orientation?: "horizontal" | "vertical";
  color?: Color;
  opacity?: "faint" | "medium" | "strong";
}

export const Separator = React.forwardRef<HTMLDivElement, SeparatorProps>(
  ({ orientation, className, color, opacity, ...props }, ref) => {
    return (
      <div
        data-opacity={opacity}
        data-color={color}
        data-orientation={orientation}
        className={cx(["p-separator", className])}
        ref={ref}
        {...props}
      ></div>
    );
  }
);

Separator.displayName = "Separator";
